var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.07568 13.2531C3.18181 13.2532 3.26899 13.3403 3.26904 13.4465V17.1652H17.6597V13.4465C17.6597 13.3403 17.7468 13.2531 17.853 13.2531H19.3013C19.4075 13.2531 19.4946 13.3403 19.4946 13.4465V18.2277C19.4945 18.6549 19.1494 19.0001 18.7222 19.0002H2.20654C1.77926 19.0002 1.43326 18.655 1.43311 18.2277V13.4465C1.43315 13.3404 1.52038 13.2533 1.62646 13.2531H3.07568ZM10.4644 2.00018C10.4935 2.00022 10.5221 2.00695 10.5483 2.01971C10.5747 2.03254 10.5986 2.05037 10.6167 2.07343L13.3208 5.49823C13.4193 5.62378 13.33 5.80876 13.1685 5.80878H11.3794V13.9777C11.3794 14.084 11.2923 14.1711 11.186 14.1711H9.73779C9.63155 14.1711 9.54443 14.084 9.54443 13.9777V5.80878H7.76025C7.59848 5.80878 7.50891 5.62327 7.60791 5.4953L10.312 2.07343C10.33 2.05055 10.3533 2.03249 10.3794 2.01971C10.4058 2.00687 10.435 2.00018 10.4644 2.00018Z",
    fill: "url(#paint0_linear_1682_5175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1682_5175",
    x1: 10.4639,
    y1: 2.00018,
    x2: 10.4639,
    y2: 34.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C244E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67DFFB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.63f80f3214e909f3162523f0527b87f4.svg";
export { ForwardRef as ReactComponent };